module.exports = __webpack_public_path__ + "img/lion.bb402deb.png";